import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const miller: NarratorNPC = {
  id: 'miller',
  name: 'Miller',
  dialog: dialog,
};
